import React, {useContext, useRef}from 'react'
import {FeatureFlagContext} from 'Contexts'

const useNzcFeature = (flag) => {
  const featureFlagContext = useContext(FeatureFlagContext)
  return useRef(featureFlagContext.featureState[flag])
}

export default useNzcFeature